import React, { useState } from "react";
import { BrowserRouter as Router } from 'react-router-dom';
import { UserProvider } from './components/user/UserContext';
import { AimdocProvider } from '@aimdoc/sdk-react';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import './App.css';
import Main from './components/Main';
// Initialize PostHog once, outside of the component
posthog.init(
  import.meta.env.VITE_PUBLIC_POSTHOG_KEY || '',
  {
    api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
    person_profiles: 'identified_only',
  }
);

function App() {
  // The dogfood widget starts hidden and Main reveals it only inside the app
  // shell: never on login, the bootstrap loader or onboarding. This has to
  // ride the provider's displayOptions (delivered with init) rather than a
  // setDisplayOptions call, which is dropped if it fires before the embed
  // script has loaded.
  const [widgetHidden, setWidgetHidden] = useState(true);
  const scriptUrl = import.meta.env.VITE_APP_URL
    ? `${import.meta.env.VITE_APP_URL}/embedded.bundle.js`
    : '/embedded.bundle.js';

  return (
    <AimdocProvider
      agentId={import.meta.env.VITE_PUBLIC_AGENT_ID}
      scriptUrl={scriptUrl}
      displayOptions={{ hidden: widgetHidden }}
    >
      <UserProvider>
        <PostHogProvider client={posthog}>
          <Router>
            <Main onWidgetHiddenChange={setWidgetHidden} />
          </Router>
        </PostHogProvider>
      </UserProvider>
    </AimdocProvider>
  );
}

export default App;
